import type { UploadMessage } from '@agio/core';

/**
 * One upload problem, explained: what is wrong, where and why, then what to
 * do — in that order. The text comes whole from the server's (or core's)
 * templates; nothing is added here.
 */
export function UploadMessageView({ message, tone }: { message: UploadMessage; tone: 'refused' | 'notice' }) {
  return (
    <div className={tone === 'refused' ? 'text-amber-950' : 'text-foreground'}>
      <p className="font-semibold">{message.title}</p>
      <p className="mt-1 text-sm leading-relaxed">{message.body}</p>
      {message.steps.length > 0 && (
        <>
          <p className="mt-2 text-sm font-medium">מה לעשות</p>
          <ol className="mt-1 list-decimal space-y-1 pe-5 text-sm">
            {message.steps.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ol>
        </>
      )}
    </div>
  );
}

/** Loaded, with things the admin should know about — shown under the success line. */
export function UploadNotices({ notices }: { notices: UploadMessage[] }) {
  if (notices.length === 0) return null;
  return (
    <div className="mt-3 rounded-md border border-amber-300 bg-amber-50 p-3">
      <p className="text-sm font-semibold text-amber-900">
        {notices.length === 1 ? 'הערה אחת על הקובץ' : `${notices.length} הערות על הקובץ`}
      </p>
      <div className="mt-2 space-y-3">
        {notices.map((n, i) => (
          <UploadMessageView key={i} message={n} tone="notice" />
        ))}
      </div>
    </div>
  );
}
